import React from "react";
import { Box, Typography } from "@mui/material";

const FooterSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#234b63",
        borderTop: "4px solid #2f6fa3",
        py: 4,
        textAlign: "center",
      }}
    >
      {/* Copyright */}
      <Typography
        sx={{
          fontFamily: "'Playfair Display', serif !important",
          fontSize: "16px !important",
          fontWeight: "500 !important",
          color: "#ffffff !important",
          mb: 1,
        }}
      >
        © 2026 Rajiv Williams. All rights reserved.
      </Typography>

      {/* Subtitle */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif !important",
          fontSize: "14px !important",
          color: "#dbe5ec !important",
          mb: 1,
        }}
      >
        Luxury Sales Coach | Real Estate Consultant | Licensed Realtor
      </Typography>

      {/* Location */}
      <Typography
        sx={{
          fontFamily: "'Lato', sans-serif !important",
          fontSize: "12px !important",
          color: "#a8c0d0 !important",
        }}
      >
        Hyderabad, Telangana, India
      </Typography>
    </Box>
  );
};

export default FooterSection;